import classNames from 'classnames';

import styles from './_index.module.scss';

export interface ButtonTextProps extends React.HTMLAttributes<HTMLButtonElement> {}

const ButtonText = <T extends React.ElementType = 'button'>({
  as,
  children,
  className,
  ...props
}: ButtonTextProps & PolymorphicProps<T>) => {
  const Component = as || 'button';
  return (
    <Component className={classNames(styles['button-text'], className)} {...props}>
      {children}
    </Component>
  );
};

export default ButtonText;
